import React, { Component } from 'react';
import { notification, Modal } from 'antd/lib';
import { withApollo, graphql, compose } from 'react-apollo';

import enviarDocumentoPorEmail from '../../../graphql/mutations/common/enviarDocumentoPorEmail.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import FormDatosEmail from '../../common/emails/FormDatosEmail';

@compose(
  graphql(getOrganismos, {
    name: 'getOrganismos',
  }),
  graphql(enviarDocumentoPorEmail, { name: 'enviarDocumentoPorEmail' })
)
class ModalMandarEmail extends Component {
  state = {
    enviandoEmail: false,
  };

  handleOk = datos => {
    this.setState({
      enviandoEmail: true,
    });
    const emailDestino = datos.emailDestino.includes('@') 
    ? datos.emailDestino 
    : `${datos.emailDestino}@jusneuquen.gov.ar`;

    this.props
      .enviarDocumentoPorEmail({
        variables: {
          _id: this.props.idDocumento,
          emailDestino: emailDestino,
          cuerpo: datos.cuerpo,
        },
      })
      .then(res => {
        if (res) {
          notification.success({
            message: 'El email se ha enviado correctamente.',
          });
          this.setState({
            enviandoEmail: true,
          });

          this.props.ocultarModalMandarEmail();
        } else {
          this.setState({
            enviandoEmail: true,
          });

          notification.error({
            message: 'Error a la hora de enviar el email, intente nuevamente.',
          });
        }
      })
      .catch(err => {
        this.setState({
          enviandoEmail: true,
        });
        console.log('ERROR AL ENVIAR EL EMAIL: ', err);
        notification.error({
          message: 'Error a la hora de enviar el email, intente nuevamente.',
        });
      });
  };

  render() {
    let organismos = this.props.getOrganismos.getOrganismos;
    if (organismos && !organismos.length) {
      return null;
    }
    return (
      <div>
        <Modal
          title="Enviar Documento por Email"
          visible={this.props.visibleModalMandarEmail}
          onCancel={this.props.ocultarModalMandarEmail}
          onOk={this.handleOk}
          width={800}
          style={{ width: 600 }}
          footer={[]}
        >
          <FormDatosEmail
            onSubmit={this.handleOk}
            organismos={organismos}
            enviandoEmail={this.state.enviandoEmail}
          />
        </Modal>
      </div>
    );
  }
}

export default withApollo(ModalMandarEmail);
